import { useEffect } from 'react';

import { useSegment } from 'shared/hooks';
import { TrackingCart } from 'shared/types/cart';
import { filterVisibleCartSummaries } from 'shared/utils/filterVisibleCartSummaries.utils';
import { trackShoppingCartView } from '../../utils/trackShoppingCart.utils';
import { useCartAction } from '../useCartAction';

export default function useTrackShoppingCartView(cart: TrackingCart) {
  const { isBusiness } = useSegment();
  const visibleSummaries = filterVisibleCartSummaries(cart.summaries);
  const { stockInfo } = useCartAction();

  useEffect(() => {
    trackShoppingCartView({
      cart,
      isBusiness,
      stockInfo,
    });
  }, [cart?.cartId, visibleSummaries[0]?.total]);
}
